import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_metronic/layout/core';
import { View } from './components/View';

const CuentasCobrarPage: FC = () => {
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Cobranza',
      path: '/cobranza/cuentas_cobrar',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Mis cuentas por cobrar</PageTitle>
      <View />
    </>
  );
};

export { CuentasCobrarPage };
